// Self-contained data for the Myrna's Jewelry concept website.
export const BIZ = {
  name: "Myrna's Jewelry",
  brand: "MYRNA'S JEWELRY",
  sub: "Repair Shop · Chinatown Gold Center",
  tagline: "Custom Name Pieces, Wedding Bands & Trusted Repairs",
  intro:
    "We're Myrna's Jewelry, a Chinatown Gold Center stall making custom name necklaces and rings, wedding bands, religious medallions, and jewelry repair.",
  address: "Stall 17-B, 2nd Floor, Chinatown Gold Center Bldg., 509–511 Ronquillo St., Santa Cruz, Manila",
  hours: "Daily, approx. 9:00 AM – 4:30 PM — please confirm before visiting",
  facebook: "https://www.facebook.com/myrnasjewelry/",
  waze: "https://www.waze.com/en-GB/live-map/directions/ph/ncr/manila/myrnas-jewelry?to=place.ChIJzSHFrJXLlzMREmMIK7er6Oc",
  youtube1: "https://www.youtube.com/watch?v=Xds3Z_jRPBo",
  youtube2: "https://www.youtube.com/watch?v=6CigTYK1hFw",
  mapEmbed: "https://www.google.com/maps?q=Chinatown+Gold+Center+509+Ronquillo+St+Santa+Cruz+Manila&output=embed",
};

export const SERVICES = [
  { title: "Custom Name Jewelry", text: "We engrave or shape necklaces and rings with a name, made to order." },
  { title: "Wedding & Engagement Rings", text: "Ready and custom gold bands, some with diamonds or gemstones." },
  { title: "Religious Medallions", text: "Gold pendants of religious imagery, a staple of our catalog." },
  { title: "Jewelry Repair", text: "Repair is part of who we are — resizing, restringing and fixes." },
];

export const PRODUCTS = [
  { name: "Personalized Name Necklace", desc: "A gold pendant spelling out a name — a signature Myrna's product.", img: "/myrna/prod-name-necklace.jpg" },
  { name: "Custom Name Rings", desc: "Cursive name rings, made in gold to order for the wearer.", img: "/myrna/prod-name-rings.jpg" },
  { name: "Diamond-Set Bangle", desc: "Gold bangle bracelet with set stones, shown in a customer pickup post.", img: "/myrna/prod-bangle.jpg" },
  { name: "Religious Gold Medallions", desc: "Small engraved religious pendants, sold as a pair or individually.", img: "/myrna/prod-medallion.jpg" },
  { name: "Ring & Earrings Set", desc: "Matching solitaire-style ring and stud earrings set in a gift box.", img: "/myrna/prod-diamond-set.jpg" },
];

export const STEPS = [
  { n: "1", title: "Browse", text: "See our name pieces, bands and medallions on our Facebook page." },
  { n: "2", title: "Message", text: "Send your name, size or repair request through Messenger." },
  { n: "3", title: "Confirm", text: "We'll discuss price, gold weight and pickup timing with you." },
  { n: "4", title: "Pick Up", text: "Collect your piece in-store at Chinatown Gold Center." },
];
